import orderImg from '../../assets/stepper/order.svg';
import boxImg from '../../assets/stepper/box.svg';
import confirmedImg from '../../assets/stepper/confirmed.svg';
import positionImg from '../../assets/stepper/position.svg';
import clockImg from '../../assets/stepper/clock.svg';

import orderBlueImg from '../../assets/stepper/orderBlue.png';
import boxBlueImg from '../../assets/stepper/boxBlue.png';
import confirmedBlueImg from '../../assets/stepper/confirmedBlue.png';
import positionBlueImg from '../../assets/stepper/positionBlue.png';
import clockBlueImg from '../../assets/stepper/clockBlue.png';

import { Container, Division } from './styles';

interface StepperProps {
  step: number;
  setStep: Function;
}

export const Stepper: React.FC<StepperProps> = ({ step, setStep }) => {
  return (
    <>
      <Container>
        <section
          className={step >= 0 ? 'activeStep' : ''}
          onClick={() => setStep(0)}
        >
          <img src={step >= 0 ? orderBlueImg : orderImg} alt="Pedido" />
          <h3>Pedido</h3>
          <div />
        </section>

        <section
          className={step >= 1 ? 'activeStep' : ''}
          onClick={() => setStep(1)}
        >
          <img src={step >= 1 ? boxBlueImg : boxImg} alt="Caixas" />
          <h3>Caixas</h3>
          <div />
        </section>

        <section
          className={step >= 2 ? 'activeStep' : ''}
          onClick={() => setStep(2)}
        >
          <img
            src={step >= 2 ? confirmedBlueImg : confirmedImg}
            alt="Recebida"
          />
          <h3>Recebida</h3>
          <div />
        </section>

        <section
          className={step >= 3 ? 'activeStep' : ''}
          onClick={() => setStep(3)}
        >
          <img src={step >= 3 ? positionBlueImg : positionImg} alt="Posições" />
          <h3>Armazém</h3>
          <div />
        </section>

        <section
          className={step >= 4 ? 'activeStep' : ''}
          onClick={() => setStep(4)}
        >
          <img src={step >= 4 ? clockBlueImg : clockImg} alt="Relógio" />
        </section>
      </Container>

      <Division />
    </>
  );
};
